import { render, staticRenderFns } from "./LedMatrix.vue?vue&type=template&id=b538a5ba&scoped=true&"
import script from "./LedMatrix.vue?vue&type=script&lang=js&"
export * from "./LedMatrix.vue?vue&type=script&lang=js&"
import style0 from "./LedMatrix.vue?vue&type=style&index=0&id=b538a5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b538a5ba",
  null
  
)

export default component.exports